// monitoring-request-edit.component.ts
import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AnalyzeTripService } from "../../../services/analyze-trip.service";
import { toCamel } from "snake-camel";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CoreService } from "../../../services/migrate/api.core.service";
import { USER_DATA } from "../../../utils/constants.util";
import { ToolsService } from "../../../services/migrate/tools.service";
import { Empresa } from "../../../models/markerModel";
import { STORAGE_KEY_CURRENT_USER } from "../../../storageCore/constStorageKeys";
import storageX from "../../../storageCore/storageX";
import { SearchComponent } from "../../../components/maps/search/search.component";
import { MatDialog } from "@angular/material/dialog";
import { MonitoringModel } from "../../../models/monitoring-model";
import { MonitoringDestinationsModel } from "../../../models/monitoring-destinations-model";

@Component({
  selector: "app-monitoring-request-edit",
  templateUrl: "./monitoring-request-edit.component.html",
  styleUrls: ["./monitoring-request-edit.component.scss"],
})
export class MonitoringRequestEditComponent implements OnInit {
  public analyzeTripService: AnalyzeTripService;
  public serviceCore: CoreService;

  public monitoringModel: MonitoringModel;
  public controlCompany = new FormControl();
  public controlCompanyName = new FormControl({ value: "", disabled: true });
  public controlVehicle = new FormControl();
  public controlDriver = new FormControl();

  public companys: any[] = [];
  public companysFiltered: Observable<any[]> = new Observable();
  public vehicles: any[] = [];
  public vehiclesFiltered: Observable<any[]> = new Observable();
  public drivers: any[] = [];
  public driversFiltered: Observable<any[]> = new Observable();

  public companiesFilter: any[] = [];
  public companiesSelect: any[] = [];
  public typeAnalyzeSelect: any[] = [];

  public reportOperationalForm: FormGroup;
  public monitoringOld: any;
  public monitoringUuid = "";
  public companyFilterSelected: any;
  public typeAnalyzeFilterSelected: any;
  public errorMessage: string;

  constructor(
    private tools: ToolsService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    analyzeTripService: AnalyzeTripService,
    apiserviceCore: CoreService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.serviceCore = apiserviceCore;
    this.analyzeTripService = analyzeTripService;
  }

  ngOnInit(): void {
    this.reportOperationalForm = this.formBuilder.group({
      selectCompany: [""],
      selectTypeAnalyze: ["", Validators.required],
      tripNumber: [{ value: "", disabled: true }],
      driverName: [""],
      expectedDepartureDate: ["", Validators.required],
      address: ["", Validators.required],
      latitude: ["", Validators.required],
      longitude: ["", Validators.required],
      listDestination: this.formBuilder.array([]),
    });

    this.typeAnalyzeSelect = [
      { name: "Análise Operacional Motorista", value: "DRIVER_OPERATIONAL" },
      { name: "Análise Operacional Veiculo", value: "VEHICLE_OPERATIONAL" },
    ];

    this.companysFiltered = this.controlCompany.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.id)),
      map((name) =>
        name ? this.filterValuesCompany(name) : this.companys.slice()
      )
    );

    this.vehiclesFiltered = this.controlVehicle.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.cdPlaca)),
      map((name) =>
        name ? this.filterValuesTerminal(name) : this.vehicles.slice()
      )
    );

    this.driversFiltered = this.controlDriver.valueChanges.pipe(
      map((value) => (typeof value === "string" ? value : value.nmNome)),
      map((name) =>
        name ? this.filterValuesDriver(name) : this.drivers.slice()
      )
    );

    this.controlVehicle.valueChanges.subscribe((value) => {
      if (typeof value === "object" && value.cdPlaca) {
        this.onVehicleSelected(value);
      }
    });

    this.monitoringUuid = this.activatedRoute.snapshot.params.uuid;
    this.loadDataElements(this.monitoringUuid);
  }

  public get destinationItems() {
    return this.reportOperationalForm.get("listDestination") as FormArray;
  }

  onVehicleSelected(selectedVehicle: any): void {
    if (selectedVehicle?.cdPlaca) {
      this.controlCompanyName.setValue(
        selectedVehicle.nmempresa || selectedVehicle.nmdivisao || ""
      );
    } else {
      this.controlCompanyName.setValue("");
    }
  }

  async loadDataElements(monitoringUuid: string) {
    try {
      this.tools.builder().spinner.show();

      const [companys, terminals, drivers] = await Promise.all([
        this.serviceCore.get<any>({
          url: "v2/companys",
          params: {
            profileId: USER_DATA().profileId,
            size: "5000",
            page: "0",
            sort: "nome",
            sortDirections: "ASC",
          },
        }),
        this.serviceCore.get<any>({
          url: "v2/terminals",
          params: {
            profileId: USER_DATA().profileId,
            size: "5000",
            page: "0",
            sortDirections: "ASC",
          },
        }),
        this.serviceCore.get<any>({
          url: "v2/drivers/getAll",
          params: {
            profileId: USER_DATA().profileId,
            size: "5000",
            page: "0",
            sort: "nome",
            sortDirections: "ASC",
          },
        }),
      ]);

      this.companys = companys.elements.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );
      this.vehicles = terminals.elements.sort((a, b) =>
        a.cdPlaca.localeCompare(b.cdPlaca)
      );
      this.drivers = drivers.elements.sort((a, b) =>
        a.nmNome.localeCompare(b.nmNome)
      );

      this.controlCompany.setValue("");
      this.controlVehicle.setValue("");
      this.controlDriver.setValue("");

      this.companiesSelect = [
        { name: "Divisão", value: 1 },
        { name: "Matriz", value: 2 },
        { name: "Filial", value: 3 },
      ];

      this.analyzeTripService
        .getByUuidMonitoring(monitoringUuid)
        .subscribe((resp) => {
          this.monitoringOld = toCamel(resp);
          this.fillTransporterData();
          this.tools.builder().spinner.hide();
        });
    } catch (error) {
      this.tools.builder().spinner.hide();
      throw new EvalError(error);
    }
  }

  fillTransporterData(): void {
    this.typeAnalyzeFilterSelected = this.monitoringOld.idDriver
      ? "DRIVER_OPERATIONAL"
      : "VEHICLE_OPERATIONAL";

    this.reportOperationalForm.patchValue({
      tripNumber: this.monitoringOld.tripNumber,
      driverName: this.monitoringOld.driverName,
      dateStart: this.monitoringOld.monitoringStartDate,
      expectedDepartureDate: this.monitoringOld.expectedDepartureDate,
      address: this.monitoringOld.address,
      latitude: this.monitoringOld.latitude,
      longitude: this.monitoringOld.longitude,
      selectTypeAnalyze: this.typeAnalyzeFilterSelected,
    });

    const selectedCompany = this.companys.find(
      (c) =>
        c.id === this.monitoringOld.idCompany ||
        c.id === this.monitoringOld.idDivision
    );

    if (selectedCompany) {
      this.companyFilterSelected =
        selectedCompany.cnpj == null
          ? "Divisão"
          : selectedCompany.idEmpresaMatriz == null
          ? "Matriz"
          : "Filial";

      this.reportOperationalForm
        .get("selectCompany")
        ?.patchValue(this.companyFilterSelected);
      this.filterCompany();

      setTimeout(() => {
        this.controlCompany.setValue(selectedCompany);

        if (this.typeAnalyzeFilterSelected === "DRIVER_OPERATIONAL") {
          const selectedDriver = this.drivers.find(
            (d) => d.id === this.monitoringOld.idDriver
          );
          if (selectedDriver) {
            this.controlDriver.setValue(selectedDriver);
          }
        } else {
          const selectedVehicle = this.vehicles.find(
            (v) => v.id === this.monitoringOld.idTerminal
          );
          if (selectedVehicle) {
            this.controlVehicle.setValue(selectedVehicle);
            this.controlCompanyName.setValue(
              selectedVehicle.nmempresa || selectedVehicle.nmdivisao || ""
            );
          }
        }
      }, 200);
    }

    const destinos = this.reportOperationalForm.get(
      "listDestination"
    ) as FormArray;
    destinos.clear();

    if (this.monitoringOld.monitoringDestinations?.length > 0) {
      this.monitoringOld.monitoringDestinations.forEach((dest: any) => {
        destinos.push(
          this.formBuilder.group({
            address: [dest.addressname, Validators.required],
            latitude: [dest.latitude, Validators.required],
            longitude: [dest.longitude, Validators.required],
          })
        );
      });
    }
  }

  openOriginAddressPopup(): void {
    const dialogRef = this.dialog.open(SearchComponent, {
      width: "400px",
      data: { mode: "fill_address" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.reportOperationalForm.patchValue({
          address: result.address,
          latitude: result.latitude,
          longitude: result.longitude,
        });
      }
    });
  }

  addDestination(): void {
    const dialogRef = this.dialog.open(SearchComponent, {
      width: "400px",
      data: { mode: "fill_address" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.destinationItems.push(
          this.formBuilder.group({
            address: [result.address, Validators.required],
            latitude: [result.latitude, Validators.required],
            longitude: [result.longitude, Validators.required],
          })
        );
      }
    });
  }

  deleteDestinationItem(index: number): void {
    this.destinationItems.removeAt(index);
  }

  displayCompany(empresa: Empresa): string {
    return empresa?.nmNome || "";
  }

  displayDriver(driver: any): string {
    return driver?.nmNome || "";
  }

  displayTerminal(terminal: any): string {
    return terminal?.cdPlaca
      ? `${terminal.cdPlaca}/${terminal.frota || ""}`
      : "";
  }

  filterValuesCompany(value: string): any[] {
    return this.companys.filter((client) =>
      client.nmNome.toLowerCase().includes(value.toLowerCase())
    );
  }

  filterValuesDriver(value: string): any[] {
    return this.drivers.filter((driver) =>
      driver.nmNome.toLowerCase().includes(value.toLowerCase())
    );
  }

  filterValuesTerminal(value: string): any[] {
    return this.vehicles.filter((client) =>
      client.cdPlaca.toLowerCase().includes(value.toLowerCase())
    );
  }

  filterCompany(): void {
    const companyModel = this.companyFilterSelected;
    if (companyModel === "Divisão") {
      this.companiesFilter = this.companys.filter((e) => e.cnpj == null);
    } else if (companyModel === "Matriz") {
      this.companiesFilter = this.companys.filter(
        (e) => e.cnpj && e.idEmpresaMatriz == null
      );
    } else if (companyModel === "Filial") {
      this.companiesFilter = this.companys.filter(
        (e) => e.cnpj && e.idEmpresaMatriz
      );
    }
  }

  async submitForm(): Promise<void> {
    this.spinner.show();

    const values = this.reportOperationalForm.value;
    const monitoringModel: MonitoringModel = {
      expectedDepartureDate: values.expectedDepartureDate + ":00",
      address: values.address,
      latitude: values.latitude,
      longitude: values.longitude,
      tripNumber: values.tripNumber,
      driverName: values.driverName,
      idCompany: this.controlCompany.value?.cnpj
        ? this.controlCompany.value.id
        : 0,
      idDivision: this.controlCompany.value?.cnpj
        ? 0
        : this.controlCompany.value.id,
      userId: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      monitoringDestinations: this.destinationItems.controls.map((control) => ({
        address: control.get("address")?.value,
        latitude: control.get("latitude")?.value,
        longitude: control.get("longitude")?.value,
      })),
      idTerminal: this.controlVehicle.value?.id || null,
      idDriver: this.controlDriver.value?.id || null,
    };

    this.analyzeTripService
      .updateMonitoring(monitoringModel, this.monitoringUuid)
      .subscribe();

    setTimeout(() => {
      this.spinner.hide();
      this.router.navigate(["/solicitacao-monitoramento"]);
    }, 3000);
  }
}
